import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { loadComponentLocaleMessages } from "./i18n";
//devx import style

// Detect system theme
// const isDarkMode =
//   window.matchMedia &&
//   window.matchMedia("(prefers-color-scheme: dark)").matches;

// // Import DevExtreme theme based on system theme
// if (isDarkMode) {
//   require("devextreme/dist/css/dx.dark.css");
// } else {
//   require("devextreme/dist/css/dx.light.css");
// }

// Create a matchMedia object
const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

// Function to switch theme
const switchTheme = (e: any) => {
	if (e.matches) {
		require("devextreme/dist/css/dx.dark.css");
	} else {
		require("devextreme/dist/css/dx.light.css");
	}
};

// Call switchTheme at run time
switchTheme(darkModeMediaQuery);

// Add listener for theme changes
darkModeMediaQuery.addEventListener("change", switchTheme);

//importo gestiore variabili / stato globale vuex
// import { useStore } from 'vuex'
import { IonicVue, modalController } from "@ionic/vue";
import { useApplicationStore } from "./stores/ApplicationStore";

import { LoginUtility } from "./views/LoginUtility/LoginUtility";

// import { store,key} from "./store";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import "devextreme/dist/css/dx.common.css";
/* Theme variables */
import "./theme/variables.css";
import "./assets/style.css";

//import environments from "@/../public/environments.json";

// eslint-disable-next-line @typescript-eslint/no-var-requires

import {
	//CommandExecutionType,
	//CommandParam,
	DataboxAPIConfig,
	//dataBoxCall,
	//DbParamType,
	// localStorageUtility,
	//ParameterDirection,
	//storeObject,
	//UserCredential,
} from "nmt_databox";
import LoginPage from "./views/Login/LoginPage.vue";
import i18n from "./i18n";

let $DATABOX_CFG: DataboxAPIConfig;

declare module "@vue/runtime-core" {
	export interface ComponentCustomProperties {
		$DATABOX_CFG: typeof $DATABOX_CFG;
	}
}

let $API_AUTH_URL: string;

declare module "@vue/runtime-core" {
	export interface ComponentCustomProperties {
		$API_AUTH_URL: typeof $API_AUTH_URL;
	}
}

let $API_DBOX_URL: string;

declare module "@vue/runtime-core" {
	export interface ComponentCustomProperties {
		$API_DBOX_URL: typeof $API_DBOX_URL;
	}
}

let $API_KEY: string;

declare module "@vue/runtime-core" {
	export interface ComponentCustomProperties {
		$API_KEY: typeof $API_KEY;
	}
}

//gestione traduzioni da rivedere
// const messages = {
//   it: {
//     introduzione: "test",
//   },
// };

const loginUtility = new LoginUtility();

// const i18n = createI18n({
//   //inizializzazione locale

//   locale: loginUtility.getLang(),
//   messages,
// });

async function openLogin() {
	//effettua un logout
	console.log("openLogin");

	//visualizza il modal di login
	const modal = await modalController.create({
		component: LoginPage, //Modal is name of the component to render inside ionic modal
		cssClass: "fullscreen",
		canDismiss: canDismiss,
	});
	return modal.present();
}

async function canDismiss() {
	return appStore.$APP_READY;
}

const pinia = createPinia();
const app = createApp(App).use(i18n).use(IonicVue).use(router).use(pinia);
console.log("appStore boot");
const appStore = useApplicationStore();

console.log("leggo file env main");

fetch("/environments.json")
	.then((response) => response.json())
	.then((environments) => {
		console.log(environments);

		app.config.globalProperties.$API_AUTH_URL = environments.API_AUTH_URL;
		app.config.globalProperties.$API_DBOX_URL = environments.API_DBOX_URL;
		app.config.globalProperties.$API_KEY = environments.API_KEY;

		appStore.$API_AUTH_URL = environments.API_AUTH_URL;
		appStore.$API_DBOX_URL = environments.API_DBOX_URL;
		appStore.$USER.Www_akey = environments.API_KEY;
		appStore.$APP_VERSION = environments.$APP_VERSION;
		appStore.$LOGIN_LOGO_IMAGE = environments.LOGIN_LOGO_IMAGE;
		appStore.$LOGIN_BACKGROUND_IMAGE = environments.LOGIN_BACKGROUND_IMAGE;
		appStore.$APP_LOGO_IMAGE = environments.APP_LOGO_IMAGE;
		appStore.$APP_LOGO_BACKGROUND_COLOR =
			environments.APP_LOGO_BACKGROUND_COLOR;
		appStore.$APP_TITLE_BACKGROUND_COLOR =
			environments.APP_TITLE_BACKGROUND_COLOR;
		appStore.$APP_TITLE_COLOR = environments.APP_TITLE_COLOR;
		appStore.$APP_TITLE = environments.APP_TITLE;

		//page-route initialization , login
		router.isReady().then(() => {
			//const store = useApplicationStore();
			loginUtility
				.LogIn(
					"",
					"",

					app.config.globalProperties.$API_AUTH_URL,
					app.config.globalProperties.$API_DBOX_URL
					//app.config.globalProperties.$API_KEY
				)
				.finally(() => {
					if (appStore.$APP_READY) {
						//vado alla home page
						app.mount("#app");
						// router.addRoute()
						router.push("/mainhome");
					} else {
						//mostro il login
						debugger;
						console.log("mostro login");
						app.mount("#app");
						openLogin();
						router.push("/mainhome");
					}
					// Expected output: 123
				})
				.catch((error) => console.log(error));
		});
	})
	.catch((error) => console.log(error));

// Read the file

// console.log(environmentConfig2);

// Get the current environment
// const currentEnvironment = process.env.NODE_ENV || "development";

// // Get the environment configuration
// const environmentConfig = environments2[currentEnvironment];

// console.log(environmentConfig);

// "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdXQiOiIiLCJ3Y2siOiJ0NkI0bWFGeWtYazNLUnRLSGZoOXI3a05tQmNYTkdzeFJmenB3bTJFdFdLa1AyQU1iQiIsInd3YyI6NzN9.nf-XAilxL-IQUqaSIPaOtLiMTufot3PQoGvq7pYJ2uo";
//app.config.globalProperties.$SITE_URL = "https://dbapv2x.niemit.com";
//app.config.globalProperties.$USR_NUTE =
//app.config.globalProperties.$USR_PSWD = "zTSUkxYxbn2Uis0O43XJr8GGNxWjtx";
//app.config.globalProperties.$CON_TOKE = "K4jfdl7oFs";
//app.config.globalProperties.$IND_CODI = "1";
// app.config.globalProperties.$LIN_CODI = 96;
//app.config.globalProperties.$USER = new UserCredential();
//app.config.globalProperties.$NALLELABEL_ID = Date.now().toString() + Math.floor(Math.random() * 1000000).toString()
//app.config.globalProperties.$axios = axios;

// //store.state.$USER.Usr_nute = "nallebio_label_app";
// //store.state.$USER.Usr_pswd = "as098w098SDldKdksdfajk";

// //imposto dati di default dell'oggetto utente
// store.$USER.Www_akey = app.config.globalProperties.$API_KEY;
// store.$USER.RegNewUser = false;
// store.$USER.Usr_vkey = "";

// if (
//   localStorageUtility.get("token") != undefined &&
//   localStorageUtility.get("token") != "null"
// ) {
//   store.$USER.JwtToken = localStorageUtility.get("token"); // $window.sessionStorage.token;
// }else {
//   store.$USER.Usr_nute = 'anonymous';
//   store.$USER.Usr_pswd = 'anonymous'
// }

// store.$USER.Rst_codi = loginUtility.getLang();
// localStorageUtility.set("Rst_codi", store.$USER.Rst_codi);
// //DevExpress.localization.locale(usr.Rst_codi); //(navigator.language || navigator.browserLanguage);
// const axoption: AxiosRequestConfig = {
//   method: "post",
//   url: app.config.globalProperties.$API_AUTH_URL,
//   //crossDomain: true,
//   data: store.$USER,
// };

// //app.config.globalProperties.$
// axios(axoption).then(
//   //funzione ok
//   function (response: any) {

//     if (typeof response.data === "object") {
//       if (response.data.Error) {
//         console.log(response.data.Error);
//       }
//       //procedo con il caricamento dei dati
//       // //e delle viste!
//       //in base alla route carico i dati che mi servono
//       if (response.data.JwtToken) {
//         store.$USER.JwtToken = response.data.JwtToken;

//         //scrivo il token nello store locale
//         localStorageUtility.set("token", store.$USER.JwtToken);
//         store.$SESSION.Usr_anon = response.data.Usr_anon;
//         if (!store.$SESSION.Usr_anon) {
//           store.$USER.Per_nome = response.data.Per_nome;
//         } else {
//           store.$USER.Per_nome = "";
//         }

//         //dichiaro app ready
//         store.$APP_READY = true;

//         //se la sessione caricata ha lingua diversa la reimposto
//         if (store.$USER.Rst_codi != response.data.Rst_codi) {
//           const lng = response.data.Rst_codi;
//           store.$USER.Rst_codi = lng;
//           localStorageUtility.set("Rst_codi", lng);
//           //DevExpress.localization.locale(lng);
//         }

//         // const prm: CommandParam[] = [];
//         // prm.push(
//         //   new CommandParam(
//         //     "@Con_toke",
//         //     "",
//         //     DbParamType.AnsiString,
//         //     10,
//         //     ParameterDirection.Input,
//         //     app.config.globalProperties.$CON_TOKE
//         //   )
//         // );
//         // prm.push(
//         //   new CommandParam(
//         //     "@Ind_codi",
//         //     "",
//         //     DbParamType.AnsiString,
//         //     10,
//         //     ParameterDirection.Input,
//         //     app.config.globalProperties.$IND_CODI
//         //   )
//         // );

//         //Definisco oggetto per la configurazione del databox
//         app.config.globalProperties.$DATABOX_CFG = new DataboxAPIConfig(
//           app.config.globalProperties.$API_DBOX_URL,
//           store.$USER.JwtToken,
//           app.config.globalProperties.$API_KEY
//         );

//         //vado alla pagina che ritengo essere l'home page
//         router.push('/tabs/tab2')
//       }else {
//         store.$APP_READY = false;
//         //mi redirigo al login
//         openLogin();
//       }

//       //monto cmq l'app in qualunque caso

//       app.mount("#app");
//     } else {
//       // invalid response
//       Promise.reject(response.data);
//       store.$APP_READY = false;
//       openLogin();
//     }

//   },
//   //funzione no ok
//   function (response: any) {
//     // something went wrong
//     ///_app.ready = false;
//     Promise.reject(response.data);
//   }
// );
